module.exports = __webpack_public_path__ + "static/media/konch-logo-with-text.e5486c9e.svg";